import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import RootProvider from './providers/root.tsx';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import 'ui_2/src/index.css';

Sentry.init({
  dsn: 'https://0794be3b5df5fc2735b9a29a15273df3@o4508779138580480.ingest.us.sentry.io/4508887208296448',
  ignoreErrors: [/window\.android\.test/],
  integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootProvider>
      <App />
    </RootProvider>
    <Toaster position='bottom-center' />
  </React.StrictMode>
);
